export function getSnippetCodeLanguage(language) {
  return language === 'javascript' || language === 'js' ? 'javascript' : 'css';
}

export function getSnippetCode(snippet) {
  return snippet.content || snippet.download?.content || '';
}

export function createDialogId(prefix, value) {
  return `${prefix}-${String(value || '')}`.toLowerCase().replace(/[^a-z0-9-_]/g, '-');
}
